// extracted by mini-css-extract-plugin
module.exports = {"morePosts":"MorePosts_morePosts___Rfwg","headline":"MorePosts_headline__cNSb_","list":"MorePosts_list__R2Dqg","post":"MorePosts_post__Yamna"};